import { combineActions, handleActions } from 'redux-actions';
import { conversationsOverviewActions } from '../../conversationsOverview/actions/conversationsOverview';
import { actions } from '../actions/conversation';
import { timelineActions } from '../actions/timeline';
const initialState = {
    timelineItems: [],
    currentRequesterId: null,
    asyncStatus: null,
    granularity: 60,
};
const { conversationGetSucceeded, conversationGetBeforeSucceeded } = actions;
const { timelineGetRequest, timelineGetSucceeded, timelineGetFailed, timelineSetGranularity, timelineClear, } = timelineActions;
const { conversationsOverviewWsStatusClosed, conversationsOverviewWsStatusOpened, conversationsOverviewWsStatusPending, } = conversationsOverviewActions;
const timeline = handleActions({
    [conversationGetBeforeSucceeded.toString()]: (state, action) => {
        const metaConversation = action.payload.metaConversation;
        if (state.currentRequesterId !== metaConversation.conversation.requested_by) {
            return Object.assign(Object.assign({}, state), { currentRequesterId: metaConversation.conversation.requested_by, timelineItems: [] });
        }
        return state;
    },
    [conversationGetSucceeded.toString()]: (state, action) => {
        const data = action.payload.data;
        if (state.currentRequesterId !== data.history.main_conversation.requested_by) {
            return Object.assign(Object.assign({}, state), { currentRequesterId: data.history.main_conversation.requested_by, timelineItems: [] });
        }
        return state;
    },
    [timelineClear.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { currentRequesterId: null, timelineItems: [] });
    },
    [timelineGetRequest.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { asyncStatus: 'loading' });
    },
    [timelineGetSucceeded.toString()]: (state, action) => {
        if (state.currentRequesterId !== action.payload.requesterId) {
            return state;
        }
        return Object.assign(Object.assign({}, state), { timelineItems: action.payload.data.conversations, asyncStatus: null });
    },
    [timelineGetFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { asyncStatus: 'failed' });
    },
    [timelineSetGranularity.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { granularity: action.payload.value });
    },
    [combineActions(conversationsOverviewWsStatusOpened, conversationsOverviewWsStatusClosed, conversationsOverviewWsStatusPending).toString()]: (state, action) => {
        const conversation = action.payload.conversation;
        for (const i in state.timelineItems) {
            if (conversation.id === state.timelineItems[i].id) {
                return Object.assign(Object.assign({}, state), { timelineItems: [
                        ...state.timelineItems.filter((o) => o.id !== conversation.id),
                        conversation,
                    ] });
            }
        }
        return state;
    },
}, initialState);
export default timeline;
